
<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="100"
            clickable-rows
            :active-page="activePage"
            :pagination="{ doubleArrows: false, align: 'center'}"
            @page-change="pageChange"
          >
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";

export default {
  name: "Province",
  data() {
    return {
      items: [],
      fields: [
        { key: "province_id", label: "ID Provinsi" },
        { key: "province_name", label: "Nama Provinsi" },
        { key: "status", label: "Status" },
      ],
      activePage: 1,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token")
    };
  },
  mounted() {
    this.authentication();
    axios
      .get(
        `${this.domain}/v1/location/province/data`,
        {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json"
          }
        }
      )
      .then(response => {
        // JSON responses are automatically parsed.
        this.items = response.data.data;
      })
      .catch(e => {
        console.log(e);
      });
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      }
    }
  },
  beforeMount() {},
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null
      } else {
        this.$router.push({ path: `/` });
      }
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
  }
};
</script>
